/**
 * Order status enums and interfaces for strong typing
 *
 * @version
 * 4.71.0 OAUI-693 Tidy and remove duplicated code
 * 4.71.0 OAUI-685 Implement tabbed sections on table
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */

/*************************************************** enums ***********************************************************/

/**
 * Delivery Status Icons Types
 */
export enum DeliveryIconTypes {
  NOT_STARTED = 'notStarted',
  SHIPPED = 'shipped',
  CANCELLED = 'cancel',
  PARTIALLY_SHIPPED = 'partiallyShipped',
  ON_HOLD = 'onHold',
  DEFAULT = 'customStatus',
}

/**
 * Order Shipping Type Status
 */
export enum OrderShippingTypeStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}

/**
 * Production Status Icon Types
 */
export enum ProductionIconTypes {
  NOT_STARTED = 'notStarted',
  IN_PRODUCTION = 'inProduction',
  READY = 'ready',
  CANCELLED = 'cancel',
  ON_HOLD = 'onHold',
  DEFAULT = 'customStatus',
}

/************************************************ interfaces **********************************************************/

/**
 * Order status model
 */
export interface IOrderStatusModel {
  index: string;
  iconId: string;
}
